$(document).ready(() => {
  /*
   * Set cookie function for disclaimer acceptance
   */
  function setDisclaimerCookie(name, value, days) {
    let expires = '';

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie =
      name + '=' + (value || '') + expires + '; path=/; samesite=strict;';
  }

  /*
   * Return the value of a specified cookie
   */
  function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  /*
   * Disclaimer form validation
   */
  window.addEventListener(
    'load',
    function() {
      // Get disclaimer form
      const disclaimerForm = document.getElementsByClassName('disclaimer-form');

      // Loop over form and prevent submission
      const validation = Array.prototype.filter.call(disclaimerForm, function(
        form
      ) {
        form.addEventListener(
          'submit',
          function(event) {
            /*
             * Check if form submitted and set disclaimer cookies
             * based on accept or decline buttons
             */
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              $('.modal-footer p').show();
            } else if (
              $('button[name="accept"]').on('click') &&
              form.checkValidity() === true
            ) {
              setDisclaimerCookie('disclaimer', 'accepted', 1);
            } else if (
              $('button[name="decline"]').on('click') &&
              form.checkValidity() === true
            ) {
              setDisclaimerCookie('disclaimer', 'declined', 1);
              window.location = $('.deny-url').data('deny-page');
            }

            form.classList.add('was-validated');
          },
          false
        );
      });
    },
    false
  );

  /*
   * Set disclaimer cookie to declined and redirect user
   * to disclaimer denied page if disclaimer declined
   */
  const $declineButton = $('.disclaimer-form button[name="decline"]');
  const $notAllowedButton = $('.disclaimer-form button[name="not-allowed"]');

  $declineButton.on('click', function() {
    setDisclaimerCookie('disclaimer', 'declined', 1);
    window.location = $('.deny-url').data('deny-page');
  });

  $notAllowedButton.on('click', function() {
    if ($('.disclaimer-form')[0].checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setDisclaimerCookie('disclaimer', 'declined', 1);
      window.location = $('.deny-url').data('deny-page');
    }
    $('.disclaimer-form').addClass('was-validated');
  });

  /*
   * Show disclaimer only if cookie is not set or is declined.
   * Add classes to <body> based on cookie values set.
   */
  const disclaimerCookie = getCookie('disclaimer');

  if (disclaimerCookie === '') {
    $('#disclaimer').modal('show');
    $('.disclaimer-overlay').removeClass('hide');
    $('body').removeClass(
      'disclaimer-accepted disclaimer-declined ' + countryClassName
    );
  } else if (disclaimerCookie === 'accepted') {
    $('.disclaimer-overlay').addClass('hide');
    $('body')
      .addClass('disclaimer-accepted ' + countryClassName)
      .removeClass('disclaimer-declined');
  } else if (disclaimerCookie === 'declined') {
    $('#disclaimer').modal('show');
    $('body')
      .addClass('disclaimer-declined')
      .removeClass('disclaimer-accepted ' + countryClassName);
  }
});

//
// Stop video from playing when modal is closed.
// <https://stackoverflow.com/a/52315492>
//
$('body').on('hide.bs.modal', '.modal', function() {
  const $modal = $(this);
  // return early if there were no embedded YouTube videos
  if ($modal.find('iframe').length === 0) return;
  const html = $modal.html();
  $modal.html(html);
});